import {memo} from 'react'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {
    StyledConversationListSkeletonContainer,
    StyledConversationItemSkeleton,
    StyledConversationContentSkeleton,
    StyledConversationFooterSkeleton
} from './style.ts'

interface ConversationListSkeletonProps {
    itemCount?: number
}

const ConversationListSkeletonComponent = ({itemCount = 5}: ConversationListSkeletonProps) => {
    return (
        <StyledConversationListSkeletonContainer direction="column" gap={2}>
            {Array.from({length: itemCount}).map((_, index) => (
                <ConversationItemSkeleton key={index} />
            ))}
        </StyledConversationListSkeletonContainer>
    )
}

const ConversationItemSkeleton = () => {
    return (
        <StyledConversationItemSkeleton direction="column" fullWidth>
            <StyledConversationContentSkeleton direction="column" gap={2.5} fullWidth>
                <Flexbox justify="space-between" gap={2} fullWidth>
                    <Flexbox direction="column" gap={1} style={{flex: 1}}>
                        <Skeleton width="70%" height={16} />
                        <Flexbox align="center" gap={1.75}>
                            <Skeleton width={6} height={6} style={{borderRadius: '50%'}} />
                            <Skeleton width="60%" height={12} />
                        </Flexbox>
                    </Flexbox>
                    <Flexbox direction="column" align="end" gap={0.5}>
                        <Skeleton width={60} height={12} />
                        <Skeleton width={80} height={12} />
                    </Flexbox>
                </Flexbox>
            </StyledConversationContentSkeleton>

            <StyledConversationFooterSkeleton align="center" gap={1.25} fullWidth>
                <Flexbox align="center" gap={1}>
                    <Skeleton width={24} height={24} style={{borderRadius: '50%'}} />
                    <Skeleton width={24} height={24} style={{borderRadius: '50%'}} />
                    <Skeleton width={24} height={24} style={{borderRadius: '50%'}} />
                </Flexbox>
                <Skeleton width="50%" height={12} style={{flex: 1}} />
                <Skeleton width={16} height={16} />
            </StyledConversationFooterSkeleton>
        </StyledConversationItemSkeleton>
    )
}

export const ConversationListSkeleton = memo(ConversationListSkeletonComponent)
